import React, { Component } from 'react';
import SignOut from 'components/signOut/signOut';
import { withRouter } from 'react-router';

import PropTypes from 'prop-types';
import logo from 'assets/images/bamboo.png';

import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem
} from 'reactstrap';

import '../nav.css';

class MerchantNav extends Component {
  constructor(props, context) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Navbar color="faded" light expand="md">
        <span>
          <NavbarBrand href="https://bambooapp.ie" target="_blank">
            <img src={logo} alt="Bamboo logo" />
          </NavbarBrand>
          <span className="logo-title">for Merchants</span>
        </span>

        <Nav className="ml-auto">
          <NavItem>
            {this.context.authUser
              ? <SignOut redirectTo="/merchant/login"></SignOut>
              : <div>
                <span className="router-link" onClick={() => { this.props.history.push('/merchant/login') }}>Log in</span>
              </div>
            }
          </NavItem>
        </Nav>

      </Navbar>
    );
  }
}

MerchantNav.contextTypes = {
  authUser: PropTypes.object,
};

const MerchantNavWithRouter = withRouter(MerchantNav);
export default MerchantNavWithRouter;